import mapKeys from 'lodash/mapKeys';
import {
	ADMINISTER_BOARD,
	ASSIGN_ISSUE,
	BULK_CHANGE,
	CREATE_ISSUE,
	DELETE_ISSUE,
	EDIT_ISSUE,
	MANAGE_SPRINT,
	TRANSITION_ISSUE,
	VIEW_BOARD,
} from '../../constants';
import type { Permission as ServicePermissionKey, ServicePermissions } from '../../types';
import {
	CAN_ASSIGN_ISSUES,
	CAN_BULK_CHANGE_ISSUES,
	CAN_CREATE_ISSUES,
	CAN_DELETE_ISSUES,
	CAN_EDIT_BOARD_CONFIG,
	CAN_EDIT_ISSUES,
	CAN_MANAGE_SPRINTS,
	CAN_TRANSITION_ISSUES,
	CAN_VIEW_BOARD,
} from './constants';
import type { PermissionKey as BacklogPermissionKey, Permissions } from './types';

const serviceToBacklogPermissions: Record<ServicePermissionKey, BacklogPermissionKey> = {
	[VIEW_BOARD]: CAN_VIEW_BOARD,
	[ADMINISTER_BOARD]: CAN_EDIT_BOARD_CONFIG,
	[BULK_CHANGE]: CAN_BULK_CHANGE_ISSUES,
	[MANAGE_SPRINT]: CAN_MANAGE_SPRINTS,
	[CREATE_ISSUE]: CAN_CREATE_ISSUES,
	[EDIT_ISSUE]: CAN_EDIT_ISSUES,
	[DELETE_ISSUE]: CAN_DELETE_ISSUES,
	[ASSIGN_ISSUE]: CAN_ASSIGN_ISSUES,
	[TRANSITION_ISSUE]: CAN_TRANSITION_ISSUES,
};

export const fromServicePermission = (permissions: ServicePermissions): Permissions =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	mapKeys(permissions, (value, key) => serviceToBacklogPermissions[key]) as Permissions;
